import React from "react";
import Settings from "./Settings";
import ReactGA from "react-ga4";

const Information = ({
  setSelectedVideo,
  setSelectedPlatform,
  selectedVideo,
  selectedPlatform,
  selectedFormat,
  setSelectedFormat,
}) => {
  const handleLariaClick = () => {
    ReactGA.event({
      category: "Outbound Link",
      action: "laria_gif_click",
      label: "Laria.ai GIF Click",
    });
  };

  return (
    <div className="information">
      <h1 className="color-accent">Check your Content</h1>

      {selectedVideo ? (
        <Settings
          setSelectedVideo={setSelectedVideo}
          selectedPlatform={selectedPlatform}
          setSelectedPlatform={setSelectedPlatform}
          selectedFormat={selectedFormat}
          setSelectedFormat={setSelectedFormat}
        />
      ) : (
        <>
          <p>
            Use this tool to ensure important elements like your logo, product,
            supers, faces, and others are within the safezone to avoid the risk
            of elements being covered within certain inventory.
          </p>
          <ul className="list">
            <li>⏰ Save time and unnecessary feedback loops</li>
            <li>📱 On device processing</li>
            <li>🚀 100% automatic and free</li>
          </ul>
          <a
            href="https://www.laria.ai"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLariaClick}
          >
            <img
              src="/images/lariaAnimationCompressed.gif"
              alt="Visit Laria.ai"
              className="laria-animation"
            />
          </a>
        </>
      )}
    </div>
  );
};

export default Information;
